module.exports = __webpack_public_path__ + "static/img/1.9647ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/clix/1.png
// module id = SyXJ
// module chunks = 35